// extracted by css-extract-rspack-plugin
export default {"dateFieldsMenuOverlay":"roadmap-date-fields-menu-module__dateFieldsMenuOverlay__NlC3_JY"};